import "./background-flash.css"

export const BACKGROUND_FLASH_CLASS =
  "animate-[background-flash_1s_ease-in-out]"
